var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrainhealthProjectLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 629.71 167.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00bff3;}.cls-2{fill:#13141e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "brand-mark"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "67.78 89.1 81.01 102.33 81.01 95.65 71.12 85.76 67.78 89.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "81.01 86.67 81.01 75.74 75.54 81.2 81.01 86.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "91.25 65.49 87.22 69.52 87.22 76.2 97.93 65.49 87.22 54.78 87.22 61.46 91.25 65.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "106.8 112.47 102.31 116.95 87.22 101.86 87.22 108.54 102.31 123.63 113.48 112.47 87.22 86.21 87.22 92.89 106.8 112.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.46,73.28,55.25,29.49,81,55.24V48.57L55.25,22.81,4.78,73.28l54.85,54.85-24.3,24.3c1.3.93,2.62,1.83,4,2.69l27-27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.99 128.34 87.22 132.12 87.22 138.79 97.67 128.34 87.22 117.89 87.22 124.57 90.99 128.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "42.74 73.41 47.41 68.74 63.14 84.46 81.01 66.6 81.01 64.33 55.25 38.58 44.14 49.69 62.87 68.43 66.21 65.09 50.82 49.69 55.25 45.26 75.46 65.46 63.14 77.79 47.41 62.06 36.06 73.41 81.01 118.36 81.01 111.68 42.74 73.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "59.79 159.55 63.13 162.88 81.01 145.01 81.01 138.33 59.79 159.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.47,93.3,87.22,147.55v6.68L141.47,100l4.6,4.59L87.22,163.42V168c.76,0,1.51-.06,2.26-.1l63.27-63.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "75.23 159.53 81.01 165.31 81.01 153.76 75.23 159.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.92,128.23.61,93.92q.48,4.08,1.34,8l29.63,29.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.91,80.93l3.34,3.34L126,68.55l36,36L154,112.5l6.53,6.53q1.06-2.31,2-4.69l-1.83-1.84,3.82-3.83c.66-2.13,1.21-4.32,1.7-6.53L126,61.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.5,125l-32.32,32.33A84.5,84.5,0,0,0,157.5,125Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.4,117,99.88,166.53a84.6,84.6,0,0,0,8.88-2.19l44-44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.26,166.51c1.93.37,3.88.69,5.86.93L70.73,164Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.22,7.7v6.68l15.06,15.06L122.56,9.16c-1.48-.77-3-1.5-4.5-2.17L102.28,22.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.22,23.14v6.67L102.39,45,132.33,15q-2-1.38-4-2.65L102.39,38.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81,32.8,53.72,5.52c-1.58.61-3.14,1.29-4.68,2l32,32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81,16.92,65.92,1.84c-1.79.39-3.56.86-5.31,1.36L81,23.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81,1.49,79.52,0c-2.06.12-4.11.29-6.14.54L81,8.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.26,11.6A84.37,84.37,0,0,0,14.89,36.21l.88.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "106.87 65.35 91.11 81.11 110.08 100.09 125.74 84.44 130.26 88.96 114.83 104.4 118.16 107.74 136.94 88.96 125.74 77.76 110.08 93.41 97.78 81.11 113.55 65.35 87.22 39.02 87.22 45.7 106.87 65.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.57,17.88l-3.34-3.34L15.66,46.11l-4.32-4.32C10.52,43.2,9.73,44.65,9,46.12l6.67,6.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118,54l-4.45-4.46,27.51-27.51C139.91,21,138.71,20,137.49,19L106.88,49.58,118,60.73l7.87-7.9,41.66,41.65c.25-2,.45-4,.56-6.11L125.88,46.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.81,38.41l-3.34,3.34,18.3,18.3a84.48,84.48,0,0,0-4-10.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.67,30.07q-1.51-1.82-3.13-3.54l-15.2,15.2L168.11,79.5c-.13-2.5-.38-5-.73-7.4L137,41.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81,129.1v-2L27.17,73.26,43,57.41l-3.34-3.34L20.49,73.26,75.33,128.1,62.65,140.81l-17.6,17.6c1.47.77,3,1.51,4.48,2.19L66,144.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.61,128.18.25,77.75C.1,79.8,0,81.86,0,83.94c0,.08,0,.16,0,.25l43.92,44L31.49,140.62,6,115.07a84.3,84.3,0,0,0,7,13.65L31.48,147.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.18,52.28c-.65,1.6-1.24,3.23-1.8,4.88l.22.21-.43.43a84.36,84.36,0,0,0-2.44,9.11l9.54-9.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.32,4.37c-1.68-.57-3.38-1.1-5.11-1.57l-4.06,4.06L96,.72Q92.35.2,88.61,0l13.54,13.54Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M196.25,121.91h8.86c4.59,0,7.91,2.94,7.91,7.61s-3.32,7.72-7.91,7.72h-6.35v9.9h-2.51Zm8.53,13.1c3.43,0,5.65-2,5.65-5.49s-2.22-5.38-5.62-5.38h-6.05V135Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M221.16,121.91h7.59a11.57,11.57,0,0,1,4.81.68,7.3,7.3,0,0,1-1,13.32V136a9.78,9.78,0,0,1,.65,1l5.58,10.15h-2.88l-5.8-10.62h-6.45v10.62h-2.52Zm8.61,12.38a4.75,4.75,0,0,0,5.07-5.13,4.65,4.65,0,0,0-2.34-4.41,7.38,7.38,0,0,0-3.65-.61h-5.17v10.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M258.48,121.48a12.85,12.85,0,0,1,13,12.89,13.06,13.06,0,1,1-26.11,0A12.86,12.86,0,0,1,258.48,121.48Zm0,23.8a10.59,10.59,0,0,0,10.43-10.91,10.43,10.43,0,1,0-20.86,0A10.56,10.56,0,0,0,258.48,145.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.89,139.07h2.52V140c0,3.88,2.37,5.28,4.7,5.28s4.67-1.3,4.67-5.21V124.14h-6.27v-2.23h8.79v18.16c0,5.46-3.69,7.5-7.22,7.5s-7.19-2.08-7.19-7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.55,121.91H317v2.23H305.07v9.18h9.73v2.23h-9.73v9.37h12.58v2.22h-15.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M337.42,121.48c6.13,0,9.23,3.27,9.23,3.27l-1.35,1.83a12.15,12.15,0,0,0-7.8-2.8,10.16,10.16,0,0,0-10.32,10.55c0,6,4.3,10.95,10.39,10.95a12,12,0,0,0,8.31-3.38l1.46,1.76a13.77,13.77,0,0,1-9.81,3.91c-7.58,0-13-5.85-13-13.2A12.61,12.61,0,0,1,337.42,121.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M361.69,124.14h-9.23v-2.23h20.93v2.23H364.2v23h-2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202,23.06h-9.23V20.83h20.93v2.23h-9.19v23H202Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M220.8,20.83h2.51V32.32h14.88V20.83h2.52V46.06h-2.52V34.54H223.31V46.06H220.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.26,20.83H265.7v2.23H253.77v9.19h9.74v2.22h-9.74v9.37h12.59v2.22h-15.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.07,63.72H209.5c6.95,0,12,3.79,12,10.34a9.48,9.48,0,0,1-5.14,8.73v.12c4.32,1.26,6.77,5.28,6.77,9.82,0,7.64-6,11.54-13.25,11.54H195.07ZM209.5,80.78a5.79,5.79,0,0,0,6.07-6.15c0-3.56-2.22-6-6.19-6h-8.53V80.78Zm.64,18.55c4.44,0,7.06-2.76,7.06-6.89s-2.8-7-7.12-7h-9.23V99.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.19,63.72h12.62c4.32,0,6.13.35,7.71.92,4.21,1.55,7,5.63,7,11,0,5.17-2.92,9.53-7.42,11v.12a11.28,11.28,0,0,1,1.23,1.83L266,104.27H259.5l-8.7-16.14H242v16.14h-5.79Zm14.08,19.47c4.5,0,7.3-2.81,7.3-7.35,0-3-1.17-5.11-3.27-6.26-1.11-.57-2.45-.92-5.67-.92H242V83.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.76,92.61H283.22l-4.09,11.66h-6L288,63.72h6.08l14.83,40.55h-6ZM291,69.29S290.05,73,289.35,75L284.74,87.9h12.5L292.68,75c-.7-2.07-1.58-5.75-1.58-5.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M319.67,63.72h5.79v40.55h-5.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M341.64,63.72h5.72L365.7,90.08c1.52,2.19,3.45,5.86,3.45,5.86h.12s-.41-3.62-.41-5.86V63.72h5.78v40.55H369L350.58,78c-1.52-2.24-3.45-5.92-3.45-5.92H347s.41,3.62.41,5.92v26.3h-5.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M391.47,63.89h4V82.27h23.83V63.89h4v40.38h-4V85.83H395.5v18.44h-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M437.62,63.89h23.13v3.57h-19.1v14.7h15.59v3.56H441.65v15H461.8v3.56H437.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M493.29,91.41H476.76l-4.67,12.86h-4.27l15.07-40.38h4.32l15.07,40.38H498ZM485,68.09s-.87,3.33-1.57,5.22L477.93,88h14.13l-5.37-14.65c-.7-1.89-1.58-5.22-1.58-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M511.63,63.89h4v36.82h19v3.56H511.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M550,67.46H535.24V63.89h33.53v3.57H554v36.81h-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M578.05,63.89h4V82.27h23.83V63.89h4v40.38h-4V85.83H582.09v18.44h-4Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "brand-name"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M623.15,91.09A6.37,6.37,0,1,1,617,97.64v-.19A6.29,6.29,0,0,1,623.15,91.09Zm0,11.79a5.43,5.43,0,1,0-5.14-5.7c0,.09,0,.18,0,.27a5.25,5.25,0,0,0,5.08,5.42ZM621.09,94h2.43a1.94,1.94,0,0,1,2.05,1.82v.22a1.79,1.79,0,0,1-1.28,1.8v0a4,4,0,0,1,.23.39l1.31,2.57h-1.08l-1.37-2.76h-1.31v2.76h-1Zm2.26,3.3a1.16,1.16,0,0,0,1.21-1.08,1.09,1.09,0,0,0,0-.18,1.1,1.1,0,0,0-1-1.21.61.61,0,0,0-.19,0h-1.28v2.47Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainhealthProjectLogo);
export default __webpack_public_path__ + "static/media/brainhealth-project-logo.4197ed97.svg";
export { ForwardRef as ReactComponent };